const select = {
  variants: {
    filled: {
      field: {
        border: "0",
        borderBottom: "2px solid",
        borderColor: "blue.650", // default blue border
        borderTopLeftRadius: "md",
        borderTopRightRadius: "md",
        borderBottomLeftRadius: "0",
        borderBottomRightRadius: "0",
        _hover: {
          bg: "gray.100",
          borderColor: "blue.650",
        },
        _focus: {
          bg: "gray.100",
          borderColor: "blue.650",
          boxShadow: "none",
        },
      },
    },
  },
};

export default select;
